import { render, staticRenderFns } from "./parent_row.vue?vue&type=template&id=18e5e55a&vue3"
import script from "./parent_row.vue?vue&type=script&lang=js&vue3"
export * from "./parent_row.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports